package org.example.project.ui

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import battleships.shared.generated.resources.Res
import battleships.shared.generated.resources.ocean
import kotlinx.coroutines.delay
import org.example.project.util.currentTimeMillis
import org.jetbrains.compose.resources.painterResource

@Composable
fun CountdownScreen(
    countdownStart: Double = 0.0,
    onFinished: () -> Unit
) {
    var count by remember { mutableStateOf(3) }

    LaunchedEffect(countdownStart) {
        if (countdownStart <= 0.0) {
            while (count > 0) {
                delay(1000)
                count--
            }
            onFinished()
            return@LaunchedEffect
        }

        val elapsed = currentTimeMillis() - countdownStart
        val remaining = (3000 - elapsed).coerceAtLeast(0.0)
        delay(remaining.toLong())

        while (count > 0) {
            delay(1000)
            count--
        }
        onFinished()
    }

    Box(modifier = Modifier.fillMaxSize()) {
        Image(
            painter = painterResource(Res.drawable.ocean),
            contentDescription = null,
            modifier = Modifier.fillMaxSize(),
            contentScale = ContentScale.Crop
        )

        Column(
            modifier = Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {
            Text(
                text = "BATTLE STARTING",
                color = Color.Cyan,
                style = MaterialTheme.typography.headlineLarge
            )

            Spacer(Modifier.height(40.dp))

            Card(
                colors = CardDefaults.cardColors(containerColor = Color(0xAA001F3F)),
                border = BorderStroke(3.dp, Color.Cyan)
            ) {
                Box(
                    modifier = Modifier.padding(horizontal = 80.dp, vertical = 40.dp),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = if (count > 0) count.toString() else "GO!",
                        color = Color.Cyan,
                        fontSize = 120.sp
                    )
                }
            }

            Spacer(Modifier.height(24.dp))

            Text(
                text = when (count) {
                    3 -> "Deploying Fleet..."
                    2 -> "Establishing Connection..."
                    1 -> "Target Locked..."
                    else -> "ENGAGE!"
                },
                color = Color.White,
                fontSize = 22.sp
            )
        }
    }
}
